import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { getLocale } from '../locale';
import { SelectRender } from '../tools/select';
import DropdownCheckboxOption from '../DropdownCheckboxOption';
import DropdownList from '../DropdownList';
import MultiSelectDropdown from '../MultiSelectDropdown';
import SelectOptions from '../SelectOptions';
import { getObjectValue } from '../tools/util';
export default SelectRender(function (context, _ref, _ref2) {
  var _triggerNode$offsetWi;

  var placeholder = _ref.placeholder,
      isOptionDisabled = _ref.isOptionDisabled,
      disableEmpty = _ref.disableEmpty,
      data = _ref.data,
      maxLength = _ref.maxLength,
      _ref$showLength = _ref.showLength,
      showLength = _ref$showLength === void 0 ? false : _ref$showLength,
      _ref$showConfirm = _ref.showConfirm,
      showConfirm = _ref$showConfirm === void 0 ? false : _ref$showConfirm,
      valueName = _ref.valueName,
      optionEcho = _ref.optionEcho,
      showAll = _ref.showAll,
      echoAll = _ref.echoAll,
      optionRender = _ref.optionRender,
      showClear = _ref.showClear,
      allOptionLabel = _ref.allOptionLabel,
      maxShowLength = _ref.maxShowLength,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {} : _ref$onSelect;
  var getValue = _ref2.getValue,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      searchProps = _ref2.searchProps,
      dropdownHeight = _ref2.dropdownHeight;
  var checkedList = context.value;
  var updateRaw = context.update,
      open = context.open,
      setOpen = context.setOpen,
      locale = context.locale,
      triggerNode = context.triggerNode;

  if (checkedList == null) {
    checkedList = [];
  }

  var checkedSet = new Set(checkedList);
  var checkedLength = checkedList.length;
  var optionsLength = data.length;
  var allChecked = checkedLength === optionsLength;
  var disableAll = data.some(isOptionDisabled);

  function update(arg) {
    if (arg && 'value' in arg) {
      onSelect(arg.value);
    }

    updateRaw(arg);
  }

  return _objectSpread(_objectSpread({}, MultiSelectDropdown(context, {
    allOptionSelected: echoAll && allChecked,
    placeholder: placeholder,
    showLength: showLength,
    value: data.filter(function (item) {
      return checkedSet.has(getValue(item));
    }),
    setOpen: setOpen,
    open: open,
    maxLength: maxLength,
    tagRender: function tagRender(item) {
      return {
        children: getObjectValue(item, optionEcho)
      };
    },
    onClose: function onClose(value) {
      update({
        value: checkedList.filter(function (i) {
          return i !== value;
        })
      });
    },
    onCloseAll: function onCloseAll() {
      update({
        value: []
      });
    },
    valueName: valueName,
    showConfirm: showConfirm,
    showClear: showClear,
    disableEmpty: disableEmpty,
    allOptionLabel: allOptionLabel,
    maxShowLength: maxShowLength,
    disableAll: disableAll,
    isOptionDisabled: isOptionDisabled
  })), {}, {
    dropdown: /*#__PURE__*/React.createElement(DropdownList, {
      width: (_triggerNode$offsetWi = triggerNode === null || triggerNode === void 0 ? void 0 : triggerNode.offsetWidth) !== null && _triggerNode$offsetWi !== void 0 ? _triggerNode$offsetWi : 0,
      maxHeight: dropdownHeight
    }, /*#__PURE__*/React.createElement(SelectOptions, searchProps, showAll && /*#__PURE__*/React.createElement(DropdownCheckboxOption, {
      checked: allChecked,
      disabled: disableAll,
      onChange: function onChange() {
        if (!disableAll) {
          update({
            value: allChecked ? [] : data.map(function (item) {
              return getValue(item);
            })
          });
        }
      },
      indeterminate: checkedLength < optionsLength && checkedLength > 0
    }, allOptionLabel !== null && allOptionLabel !== void 0 ? allOptionLabel : getLocale(locale).common.all), options.map(function (item) {
      var value = getValue(item);
      var disabled = isOptionDisabled(item);
      return /*#__PURE__*/React.createElement(DropdownCheckboxOption, {
        key: value,
        disabled: disabled,
        checked: checkedSet.has(value),
        onChange: function onChange() {
          if (!disabled) {
            update({
              value: checkedSet.has(value) ? checkedList.filter(function (i) {
                return i !== value;
              }) : checkedList.concat(value)
            });
          }
        }
      }, optionRender(item));
    })))
  });
});